
import TableHeader from '@/components/table_header/index.vue'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'
import AuthTable from './components/authTable.vue'
import { StatusPlain } from './config/auth'
import { MediaService } from '@/services'
import { Component, Vue, Ref } from 'vue-property-decorator'

@Component({
    name: 'MediaAuth',
    components: {
        TableHeader,
        ScrollTo,
        AuthTable
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType
    private pageSize = 15
    private pageIndex = 1
    private curStatus = StatusPlain.Ing.key
    private pageTotal = 0
    private isLoading = true
    private authList: any[] = []

    get statusList() {
        return Object.values(StatusPlain)
    }

    private onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(this.getList)
    }

    private mounted() {
        this.getList()   
    }

    /* 获取审核列表 */
    private async getList() {
        this.isLoading = true
        const params = {
            status: this.curStatus,
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        const result = await MediaService.getAuthList(params)
        this.isLoading = false
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.authList = result.data.list
        }
    }
}
